module.exports = __webpack_public_path__ + "media/images/about-old-09800b7738ae584fdf0cefd6cd76be59.jpg";